/* eslint-disable */
import React from "react";
import get_preview_url from "../utils/get-preview-url";

const PreviewLinkForm = ({ ITEM_ID, MODEL_TYPE, Item_Value }) => {
  return (
    <form className="container__form" onSubmit={handleSubmit}>
      <button>Go To Preview Link </button>
    </form>
  );

  function handleSubmit(e) {
    e.preventDefault();
    const PREVIEW_URL = get_preview_url(MODEL_TYPE, ITEM_ID, Item_Value);
    window.open(PREVIEW_URL, "_blank");
  }
};
export default PreviewLinkForm;
